var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5531 2.68343C10.6206 2.03065 9.37936 2.03065 8.44683 2.68343L3.44683 6.18343C2.72282 6.69023 2.29163 7.51841 2.29163 8.40218V16.6667C2.29163 17.242 2.758 17.7083 3.33329 17.7083H16.6666C17.2419 17.7083 17.7083 17.242 17.7083 16.6667V8.40218C17.7083 7.51841 17.2771 6.69023 16.5531 6.18343L11.5531 2.68343ZM7.73 1.65939C9.09294 0.705335 10.907 0.705333 12.2699 1.65939L17.2699 5.15939C18.3281 5.9001 18.9583 7.11052 18.9583 8.40218V16.6667C18.9583 17.9323 17.9323 18.9583 16.6666 18.9583H3.33329C2.06764 18.9583 1.04163 17.9323 1.04163 16.6667V8.40218C1.04163 7.11052 1.67184 5.9001 2.73 5.15939L7.73 1.65939Z",
    fill: "#2C3A4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 9.99992C4.375 8.73427 5.40101 7.70825 6.66667 7.70825H13.3333C14.599 7.70825 15.625 8.73427 15.625 9.99992V18.3333H14.375V9.99992C14.375 9.42462 13.9086 8.95825 13.3333 8.95825H6.66667C6.09137 8.95825 5.625 9.42462 5.625 9.99992V18.3333H4.375V9.99992Z",
    fill: "#2C3A4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 11.6667C15.625 12.0119 15.3452 12.2917 15 12.2917L5 12.2917C4.65482 12.2917 4.375 12.0119 4.375 11.6667C4.375 11.3216 4.65482 11.0417 5 11.0417L15 11.0417C15.3452 11.0417 15.625 11.3216 15.625 11.6667Z",
    fill: "#2C3A4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 15C15.625 15.3452 15.3452 15.625 15 15.625L5 15.625C4.65482 15.625 4.375 15.3452 4.375 15C4.375 14.6548 4.65482 14.375 5 14.375L15 14.375C15.3452 14.375 15.625 14.6548 15.625 15Z",
    fill: "#2C3A4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFinance);
export default __webpack_public_path__ + "static/media/svg_finance.972ea6bf20fa69b6f34c17185a951180.svg";
export { ForwardRef as ReactComponent };